import React from 'react';
import classNames from 'classnames';
import Button from '@profile/src/Components/Touchable';
import styles from './styles.module.scss';
import icCloseWhite from 'assets/svg/ic_close.svg';
import { openInNewTab } from '@profile/src/ConnectWallet_V2/utils';
import { CONTACT_SUPPORT_URL } from '@profile/src/constants';

const WarningUserBanned = ({
  className,
  onClose
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.txt
  }, "Your game account has been banned. It means that you will be unable to claim In-game Currency."), /*#__PURE__*/React.createElement(Button, {
    className: styles.btn,
    onClick: () => openInNewTab(CONTACT_SUPPORT_URL)
  }, /*#__PURE__*/React.createElement("span", null, "Contact Support"))), /*#__PURE__*/React.createElement("img", {
    onClick: onClose,
    className: styles.close,
    src: icCloseWhite
  }));
};

export default WarningUserBanned;